module.exports = __webpack_public_path__ + "img/pediatrics.cc3f2f73.png";